import { Button, Input } from 'antd'
import React, { useState } from 'react'

const SearchPage = ({setSearch, size}) => {
  const [searchInput, setSearchInput] = useState('')
  const handleSearch = () => {
    setSearch(searchInput)
  }
  return (
    <>
      <div>
        <Input placeholder='Search...' size={"large"} onChange={({target:{value}})=> setSearchInput(value)} />
      </div>
      <Button onClick={handleSearch} className='!bg-light_blue mx-2' type='primary' size='large'>Search</Button>
    </>
  )
}

export default SearchPage